import StudentCourseMenu from '../shared/student_course_menu';
import StudentCourseAccordion from './accordion';

function HomeworksContainer(props) {
  return (<StudentCourseMenu render={renderContent.bind(null, props)}/>);
}

function renderContent(props, studentCourse) {
  return (<StudentCourseAccordion studentCourse={studentCourse}/>);
}

export default HomeworksContainer;
